// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistics_statsContainer__blF5q {
  --stats-surface: var(--bg-surface, #15182e);
  --stats-surface-alt: var(--bg-elevated, #1c2030);
  --stats-border: var(--border, rgba(255, 255, 255, 0.08));
  --stats-text: var(--text-primary, #f1f5f9);
  --stats-text-secondary: var(--text-secondary, #94a3b8);

  --stats-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  --stats-shadow-hover: 0 4px 16px rgba(0, 0, 0, 0.45);

  padding: 16px;
  max-width: 1400px;
  margin: 0 auto;
}

.statistics_statsCard__5f8k4 {
  border-radius: var(--radius-sm, 8px);
  border: 1px solid var(--stats-border);
  box-shadow: var(--stats-shadow);
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

.statistics_statsCard__5f8k4:hover {
  box-shadow: var(--stats-shadow-hover);
}

.statistics_statsCard__5f8k4 .ant-card-body {
  padding: 16px;
}

.statistics_statsCard__5f8k4 .ant-card-head {
  padding: 0 16px;
  min-height: 40px;
  border-bottom: 1px solid var(--stats-border);
}

.statistics_statsCard__5f8k4 .ant-card-head-title {
  padding: 10px 0;
  font-size: 14px;
}

.statistics_statsCard__5f8k4 .ant-table {
  font-size: 13px;
}

.statistics_statsCard__5f8k4 .ant-table-thead > tr > th {
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
}

.statistics_statsCard__5f8k4 .ant-table-tbody > tr > td {
  padding: 8px 12px;
}

.statistics_statsCard__5f8k4 .ant-statistic-title {
  font-size: 12px;
  margin-bottom: 4px;
}

.statistics_statsCard__5f8k4 .recharts-wrapper {
  font-size: 12px;
}

.statistics_metricCard__87e4R {
  --metric-accent: var(--accent, #3b82f6);
  position: relative;
  min-height: 92px;
  padding: 14px 56px 14px 14px;
  border-radius: var(--radius-sm, 8px);
  border: 1px solid var(--stats-border);
  background: var(--stats-surface);
  color: var(--stats-text);
  overflow: hidden;
}

.statistics_metricCardCompact__Ha8fG {
  min-height: 76px;
  padding: 12px 44px 12px 12px;
}

.statistics_metricCardCompact__Ha8fG .statistics_metricValue__13jPn {
  font-size: 21px;
}

.statistics_metricCardCompact__Ha8fG .statistics_metricIcon__EZyD- {
  right: 12px;
  font-size: 24px;
}

.statistics_metricValue__13jPn {
  font-size: 26px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--metric-accent);
  margin-bottom: 2px;
  overflow-wrap: anywhere;
}

.statistics_metricLabel__nw2ta {
  font-size: 12px;
  line-height: 1.4;
  color: var(--stats-text-secondary);
}

.statistics_metricAffix__-Icz0 {
  font-size: 0.7em;
  opacity: 0.8;
  margin: 0 2px;
}

.statistics_metricTrend__TmfuG {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 500;
}

.statistics_metricIcon__EZyD- {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 28px;
  line-height: 1;
  color: var(--metric-accent);
  opacity: 0.28;
  pointer-events: none;
}

.statistics_metricCard__87e4R.statistics_info__W0EXM {
  --metric-accent: var(--accent-cyan, #06b6d4);
}

.statistics_metricCard__87e4R.statistics_success__14lTq {
  --metric-accent: var(--success, #22c55e);
}

.statistics_metricCard__87e4R.statistics_danger__XPJDu {
  --metric-accent: var(--danger, #f87171);
}

.statistics_chartTitle__5mK2Y {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--stats-text);
}

.statistics_chartTitleIcon__8UcIA {
  flex: none;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: var(--accent-grad, linear-gradient(135deg, #3b82f6, #06b6d4));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
}

.statistics_modernButton__lwyE1 {
  border: none;
  border-radius: var(--radius-sm, 8px);
  font-weight: 500;
  font-size: 13px;
  color: #fff;
  background: var(--accent-grad, linear-gradient(135deg, #3b82f6, #06b6d4));
  box-shadow: 0 1px 4px var(--accent-glow, rgba(59, 130, 246, 0.25));
  transition: box-shadow 0.2s ease, opacity 0.2s ease;
}

.statistics_modernButton__lwyE1:hover,
.statistics_modernButton__lwyE1:focus,
.statistics_modernButton__lwyE1:active {
  color: #fff;
  opacity: 0.92;
  box-shadow: 0 2px 10px var(--accent-glow, rgba(59, 130, 246, 0.25));
}

.statistics_modernButton__lwyE1:disabled,
.statistics_modernButton__lwyE1:disabled:hover {
  opacity: 0.45;
  box-shadow: none;
}

.statistics_modernSelect__iTpPm .ant-select-selector {
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.statistics_customProgress__r3cHZ .ant-progress-inner {
  background: var(--stats-surface-alt);
}

.statistics_modernAlert__cCwpK {
  border-radius: var(--radius-sm, 8px);
}

.statistics_statsContainer__blF5q .ant-spin-container {
  min-height: 200px;
}

.statistics_statsContainer__blF5q .ant-badge-dot {
  box-shadow: 0 0 0 1px var(--stats-surface);
}

.statistics_rateList__oB0zg {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.statistics_rateRow__Znz2y {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.statistics_rateHeader__yAjl4 {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

@media (max-width: 768px) {
  .statistics_statsContainer__blF5q {
    padding: 12px;
  }

  .statistics_metricValue__13jPn {
    font-size: 24px;
  }

  .statistics_metricIcon__EZyD- {
    font-size: 26px;
  }

  .statistics_modernTabs__LEXly .ant-tabs-tab {
    padding: 6px 8px;
    font-size: 12px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .statistics_statsCard__5f8k4,
  .statistics_modernButton__lwyE1,
  .statistics_modernSelect__iTpPm .ant-select-selector {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Statistics/statistics.module.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,wDAAwD;EACxD,0CAA0C;EAC1C,sDAAsD;;EAEtD,6CAA6C;EAC7C,oDAAoD;;EAEpD,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,yEAAyE;EACzE,kEAAkE;EAClE,mDAAmD;AACrD;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,mEAAmE;AACrE;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF","sourcesContent":[".statsContainer {\n  --stats-surface: var(--bg-surface, #15182e);\n  --stats-surface-alt: var(--bg-elevated, #1c2030);\n  --stats-border: var(--border, rgba(255, 255, 255, 0.08));\n  --stats-text: var(--text-primary, #f1f5f9);\n  --stats-text-secondary: var(--text-secondary, #94a3b8);\n\n  --stats-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);\n  --stats-shadow-hover: 0 4px 16px rgba(0, 0, 0, 0.45);\n\n  padding: 16px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.statsCard {\n  border-radius: var(--radius-sm, 8px);\n  border: 1px solid var(--stats-border);\n  box-shadow: var(--stats-shadow);\n  overflow: hidden;\n  transition: box-shadow 0.2s ease;\n}\n\n.statsCard:hover {\n  box-shadow: var(--stats-shadow-hover);\n}\n\n.statsCard :global(.ant-card-body) {\n  padding: 16px;\n}\n\n.statsCard :global(.ant-card-head) {\n  padding: 0 16px;\n  min-height: 40px;\n  border-bottom: 1px solid var(--stats-border);\n}\n\n.statsCard :global(.ant-card-head-title) {\n  padding: 10px 0;\n  font-size: 14px;\n}\n\n.statsCard :global(.ant-table) {\n  font-size: 13px;\n}\n\n.statsCard :global(.ant-table-thead > tr > th) {\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.statsCard :global(.ant-table-tbody > tr > td) {\n  padding: 8px 12px;\n}\n\n.statsCard :global(.ant-statistic-title) {\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.statsCard :global(.recharts-wrapper) {\n  font-size: 12px;\n}\n\n.metricCard {\n  --metric-accent: var(--accent, #3b82f6);\n  position: relative;\n  min-height: 92px;\n  padding: 14px 56px 14px 14px;\n  border-radius: var(--radius-sm, 8px);\n  border: 1px solid var(--stats-border);\n  background: var(--stats-surface);\n  color: var(--stats-text);\n  overflow: hidden;\n}\n\n.metricCardCompact {\n  min-height: 76px;\n  padding: 12px 44px 12px 12px;\n}\n\n.metricCardCompact .metricValue {\n  font-size: 21px;\n}\n\n.metricCardCompact .metricIcon {\n  right: 12px;\n  font-size: 24px;\n}\n\n.metricValue {\n  font-size: 26px;\n  line-height: 1.2;\n  font-weight: 600;\n  color: var(--metric-accent);\n  margin-bottom: 2px;\n  overflow-wrap: anywhere;\n}\n\n.metricLabel {\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--stats-text-secondary);\n}\n\n.metricAffix {\n  font-size: 0.7em;\n  opacity: 0.8;\n  margin: 0 2px;\n}\n\n.metricTrend {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 6px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.metricIcon {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 28px;\n  line-height: 1;\n  color: var(--metric-accent);\n  opacity: 0.28;\n  pointer-events: none;\n}\n\n.metricCard.info {\n  --metric-accent: var(--accent-cyan, #06b6d4);\n}\n\n.metricCard.success {\n  --metric-accent: var(--success, #22c55e);\n}\n\n.metricCard.danger {\n  --metric-accent: var(--danger, #f87171);\n}\n\n.chartTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--stats-text);\n}\n\n.chartTitleIcon {\n  flex: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  background: var(--accent-grad, linear-gradient(135deg, #3b82f6, #06b6d4));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  color: #fff;\n}\n\n.modernButton {\n  border: none;\n  border-radius: var(--radius-sm, 8px);\n  font-weight: 500;\n  font-size: 13px;\n  color: #fff;\n  background: var(--accent-grad, linear-gradient(135deg, #3b82f6, #06b6d4));\n  box-shadow: 0 1px 4px var(--accent-glow, rgba(59, 130, 246, 0.25));\n  transition: box-shadow 0.2s ease, opacity 0.2s ease;\n}\n\n.modernButton:hover,\n.modernButton:focus,\n.modernButton:active {\n  color: #fff;\n  opacity: 0.92;\n  box-shadow: 0 2px 10px var(--accent-glow, rgba(59, 130, 246, 0.25));\n}\n\n.modernButton:disabled,\n.modernButton:disabled:hover {\n  opacity: 0.45;\n  box-shadow: none;\n}\n\n.modernSelect :global(.ant-select-selector) {\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.customProgress :global(.ant-progress-inner) {\n  background: var(--stats-surface-alt);\n}\n\n.modernAlert {\n  border-radius: var(--radius-sm, 8px);\n}\n\n.statsContainer :global(.ant-spin-container) {\n  min-height: 200px;\n}\n\n.statsContainer :global(.ant-badge-dot) {\n  box-shadow: 0 0 0 1px var(--stats-surface);\n}\n\n.rateList {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.rateRow {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.rateHeader {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n@media (max-width: 768px) {\n  .statsContainer {\n    padding: 12px;\n  }\n\n  .metricValue {\n    font-size: 24px;\n  }\n\n  .metricIcon {\n    font-size: 26px;\n  }\n\n  .modernTabs :global(.ant-tabs-tab) {\n    padding: 6px 8px;\n    font-size: 12px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .statsCard,\n  .modernButton,\n  .modernSelect :global(.ant-select-selector) {\n    transition: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statsContainer": `statistics_statsContainer__blF5q`,
	"statsCard": `statistics_statsCard__5f8k4`,
	"metricCard": `statistics_metricCard__87e4R`,
	"metricCardCompact": `statistics_metricCardCompact__Ha8fG`,
	"metricValue": `statistics_metricValue__13jPn`,
	"metricIcon": `statistics_metricIcon__EZyD-`,
	"metricLabel": `statistics_metricLabel__nw2ta`,
	"metricAffix": `statistics_metricAffix__-Icz0`,
	"metricTrend": `statistics_metricTrend__TmfuG`,
	"info": `statistics_info__W0EXM`,
	"success": `statistics_success__14lTq`,
	"danger": `statistics_danger__XPJDu`,
	"chartTitle": `statistics_chartTitle__5mK2Y`,
	"chartTitleIcon": `statistics_chartTitleIcon__8UcIA`,
	"modernButton": `statistics_modernButton__lwyE1`,
	"modernSelect": `statistics_modernSelect__iTpPm`,
	"customProgress": `statistics_customProgress__r3cHZ`,
	"modernAlert": `statistics_modernAlert__cCwpK`,
	"rateList": `statistics_rateList__oB0zg`,
	"rateRow": `statistics_rateRow__Znz2y`,
	"rateHeader": `statistics_rateHeader__yAjl4`,
	"modernTabs": `statistics_modernTabs__LEXly`
};
export default ___CSS_LOADER_EXPORT___;
